import React, { useState, useCallback } from 'react';
import Toast from './Toast';
import './Toast.css';

let toastFunction = () => { };

export const toast = ({ type = 'info', message }) => {
    toastFunction({ type, message });
};

const ToastContainer = () => {
    const [toasts, setToasts] = useState([]);

    const removeToast = useCallback((id) => {
        setToasts(prev => prev.filter(toast => toast.id !== id));
    }, []);

    // Store the addToast function in the closure
    toastFunction = ({ type, message }) => {
        const id = Date.now();
        setToasts(prev => [...prev, { id, type, message }]);
    };

    return (
        <div className="toast-container">
            {toasts.map(({ id, type, message }) => (
                <Toast
                    key={id}
                    type={type}
                    message={message}
                    onDismiss={() => removeToast(id)}
                />
            ))}
        </div>
    );
};

export default ToastContainer;
